import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const FaceId = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.5 * (24 / size),
        strokeLinecap: "round",
        strokeLinejoin: "round",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8v-2a2 2 0 0 1 2 -2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16v2a2 2 0 0 0 2 2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 20h2a2 2 0 0 0 2 -2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10l.01 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10l.01 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 15a3.5 3.5 0 0 0 4 0"
            })
        ]
    });
};
